import useExtraDialog from "@components/_hooks/Cart/useExtraDialog";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import dynamic from "next/dynamic";
import { Fragment } from "react";

const ProductExtrasDialog = dynamic(() => import("../ProductExtrasDialog"), {ssr: false});

const ProductCard = dynamic(() => import("@components/Components/Reusables/ProductCard"))
const CategoryProductTile = dynamic(() => import("../../CategoryComponent/Products/CategoryProductTile"))
const Slider = dynamic(() => import("react-slick"));
const NextArrow = dynamic(() => import("@components/Components/Reusables/Slick/NextArrow"));
const PrevArrow = dynamic(() => import("@components/Components/Reusables/Slick/PrevArrow"));


const slickPrev = {
    fontSize: 0,
    lineHeight: 0,
    position: 'absolute',
    top: '35%',
    display: 'block',
    width: '35px',
    height: '35px',
    padding: 0,
    cursor: 'pointer',
    color: 'white',
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
    zIndex: 2,
	transition: 'all 0.2s ease-in-out',
    ':hover': {
		backgroundColor: 'primary.main',
		color: 'primary.contrastText',
    },
	borderRadius: 0
}


var settings = {
    dots: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: true,
    // autoplay: true,
    touchThreshhold: 100,
    speed: 500,
    autoplaySpeed: 2000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow:  4,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
        }
      },
      {
        breakpoint: 940,
        settings: {
          slidesToShow:  3,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow:  2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow:2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 350,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        }
      },
    ],
}
const ProductCarousel = ({ productData, products, package_core, long_term, sectionID = null, elevation, addToQuoteComponent = false }) => {
    const extrasHook = useExtraDialog();
    const {open, handleToggle, extraProductData, setExtraProductData} = extrasHook;
    


  // const newProduct = [...products, ...products]
    
    return (
      <>
      {open && extraProductData?.product?.product_id && (
        <ProductExtrasDialog extrasData={extraProductData} open={open} toggle={handleToggle} />
      )}
      <Box 
        sx={{
          ':hover': {
              '& .slick-arrow-prev': { opacity: 1, left: '18px' },
              '& .slick-arrow-next': { opacity: 1, right: '18px' },
            },
            '& .slick-arrow-prev': { left: '8px', opacity: 0 },
            '& .slick-arrow-next': { right: '8px', opacity: 0 },

            '& .slick-list': { overflow: 'hidden' },
            '& .slick-track': { display: 'flex !important', width: '100% !important' },
            '& .slick-slide': {
              display: 'block !important',
              height: 'auto',
              boxSizing: 'border-box',
              flex: '0 0 calc(100% / 5) !important',
              width: 'calc(100% / 5) !important',
            },
            '& .slick-slide > div': { padding: '0 4px', boxSizing: 'border-box', height: '100%' },
            // Grid for SSR
            '@media (max-width:1500px)': {
              '& .slick-slide': { flexBasis: 'calc(100% / 4) !important', width: 'calc(100% / 4) !important' },
            },
            '@media (max-width:1000px)': {
              '& .slick-slide': { flexBasis: 'calc(100% / 3) !important', width: 'calc(100% / 3) !important' },
            },
            '@media (max-width:768px)': {
              '& .slick-slide': { flexBasis: 'calc(100% / 2) !important', width: 'calc(100% / 2) !important' },
            },
        }}
      >
        <Slider  {...settings}>
          {products.map((product, idx) => (
            <Fragment key={product.product_id}>
              <CategoryProductTile
                  long_term={long_term}
                  props={productData}
                  product={product}
                  source={"home"}
                  sectionID={sectionID}
                  gridProps={{
                    xs: 12
                  }}
                  elevation={elevation}
                  addToQuoteComponent={addToQuoteComponent}
                  package_core={package_core}
                  extrasHook={extrasHook}
              />
            </Fragment>
          ))}
        </Slider>
      </Box>
      </>
    );
};

export default ProductCarousel;
